"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppImage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const FastImage_1 = __importDefault(require("../ui-components/FastImage"));
const colors_1 = require("../../common/colors");
/**
 *
 * @param props
 * @returns
 */
const AppImage = (props) => {
    //AppImageProps
    const { url, size = "xs", addRadius = true, cache = false, style, ...rest } = props;
    const [isError, setError] = (0, react_1.useState)(false);
    const onError = (0, react_1.useCallback)(() => {
        // console.log("API error?:", url);
        setError(true);
    }, []);
    const onLoad = (0, react_1.useCallback)(() => {
        // console.log("Image loaded?:", url);
        setError(false);
    }, []);
    const IMAGE_SIZE = size || "xs";
    const sizes = (0, react_1.useMemo)(() => {
        return {
            tabHead: {
                width: 42,
                height: 42,
            },
            xs: {
                width: 60,
                height: 60,
            },
            sm: {
                //done
                width: 84,
                height: 84,
            },
            lg: {
                // done
                width: 110,
                height: 110,
            },
            xl: {
                //done
                width: 120,
                height: 120,
            },
            slide: {
                //done
                width: 900,
                height: 700,
            },
        };
    }, []);
    return ((0, jsx_runtime_1.jsx)(FastImage_1.default, { style: {
            maxWidth: "100%",
            maxHeight: "100%",
            width: sizes?.[size]?.width,
            height: sizes?.[size]?.height,
            borderColor: colors_1.Colors.DARK_600,
            borderWidth: props?.borderWidth ?? 2,
            ...(addRadius && { borderRadius: sizes?.[IMAGE_SIZE]?.width / 2 }),
            ...style,
        }, source: {
            uri: `${url}`,
            // priority: FastImage.priority.normal,
            // ...(cache && { cache: FastImage.cacheControl.cacheOnly }),
        }, onLoad: onLoad, onError: onError, resizeMode: "cover", ...rest }));
};
exports.AppImage = AppImage;
